import { Component, Inject, LOCALE_ID, Renderer2 } from '@angular/core';
import { ConfigService } from '../@vex/services/config.service';
import { Settings } from 'luxon';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { NavigationService } from '../@vex/services/navigation.service';
import icLayers from '@iconify/icons-ic/twotone-layers';
import icDashboard from '@iconify/icons-ic/twotone-dashboard';
import faAddressCard from '@iconify/icons-fa-solid/address-card';
import faFolderOpen from '@iconify/icons-fa-solid/folder-open';
import { LayoutService } from '../@vex/services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { SplashScreenService } from '../@vex/services/splash-screen.service';
import { Style, StyleService } from '../@vex/services/style.service';
import { ConfigName } from '../@vex/interfaces/config-name.model';
import { CookieService } from 'ngx-cookie-service';
import { BroadcastService } from './services/broadcast.service';
import { Message } from './interfaces/message.model';
import { active_session_details, UsersService } from './services/users.service';
import { AppConfigService } from './services/app-config.service';
import { userPrivileges } from './components/login/login.component';
import { BusinessGroupManagementService } from './services/business-group-management.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Stats } from 'fs';

export let systemCatalogsInfo:any = [];

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})



export class AppComponent {
  title = 'vex';
  userPrivileges: any;
  service_brought: any = ''
  privilegesObj: any = {};

  sideNavItems = {
    //administration - user management, platform settings, roles
    administration: {
      type: 'dropdown',
      label: 'Administration',
      icon: faFolderOpen,
      children: []
    },
    
    transcoding: {
      type: 'dropdown',
      label: 'Transcoding',
      icon: faFolderOpen,
      children: [
        // {
        //   type: 'link',
        //   label: 'Catalogs',
        //   route: '/cms/transcoding/catalogs',
        //   icon: faAddressCard,

        // },
        // {
        //   type: 'link',
        //   label: 'Stats',
        //   route: '/cms/transcoding/stats',
        //   icon: faAddressCard,
        // },
        // {
        //   type: 'link',
        //   label: 'List of Items',
        //   route: '/cms/transcoding/list_of_items',
        //   icon: faAddressCard,
        // },

        {

          type: 'link',
          label: 'Publish Settings',
          route: '/cms/transcoding/publish_settings',
          icon: faAddressCard,
        },
        {

          type: 'link',
          label: 'Profile Settings',
          route: '/cms/transcoding/transcoding_profile_settings',
          icon: faAddressCard,
        }


      ]
    },

    content_management: {
      type: 'dropdown',
      label: 'Content Management',
      icon: faFolderOpen,
      children: [
        // route has to be changed
        {
          type: 'link',
          label: 'Catalogs',
          route: '/cms/catalogs',
          icon: faAddressCard,
        },
        {
          type: 'link',
          label: 'Containers',
          route: '/cms/media_list',
          icon: faAddressCard,
          icon1: faAddressCard,
        },
        {
          type: 'link',
          label: 'All Contents',
          route: '/cms/all-contents',
          icon: faAddressCard,
          icon1: faAddressCard,
        },
        {
          type: 'link',
          label: 'Bulk Upload/Update Info',
          route: '/cms/bulk_list',
          icon: faAddressCard,
        },

      ]
    },

    monetization: {
      type: 'dropdown',
      label: 'Monetization',
      icon: faFolderOpen,
      children: [
        {
          type: 'dropdown',
          label: 'Content Control',
          icon: faFolderOpen,
          children: [
            // {
            //       type: 'link',
            //       label: 'Add Content Control',
            //       route: '/cms/monetization/add-new-content-control',
            //       icon: faAddressCard,
            // },
            {
              type: 'link',
              label: 'All Content Control',
              route: '/cms/monetization/all-content-control',
              icon: faAddressCard,
            }

          ]
        },
        {
          type: 'dropdown',
          label: 'Subsription Plans',
          icon: faFolderOpen,
          children: [

            {
              type: 'link',
              label: 'View All Plans',
              route: '/cms/monetization/subscription/view-all-plans',
              icon: faAddressCard,
            },
            {
              type: 'link',
              label: 'End User Details',
              route: '/cms/monetization/subscription/end-user-details',
              icon: faAddressCard,
            },
            {
              type: 'link',
              label: 'Transaction Details',
              route: '/cms/monetization/subscription/transaction-details',
              icon: faAddressCard,
            },
          ]

        }
      ]
    },

    configurations: {
      type: 'dropdown',
      label: 'Configurations',
      icon: faFolderOpen,
      children: [
        {
          type: 'link',
          label: 'App Configuration',
          icon: faAddressCard,
          route: '/cms/apps-config',
        }
      ]
    },
    // user_management - add user, all user
    user_management: {
      type: 'dropdown',
      label: 'User Management',
      icon: faAddressCard,
      children: [
        {
          type: 'link',
          label: 'All Users',
          route: '/cms/user_managment/all_users_list',
          icon: faAddressCard,
        },
      ]
    },

    add_user: {
      type: 'link',
      label: 'Add User',
      route: '/cms/user_managment/user_add',
      icon: faAddressCard,
    },

    platformSettings: {

      type: 'link',
      label: 'Platform Settings',
      route: '/cms/platform_settings',
      icon: faAddressCard,
    },

    roles: {

      type: 'link',
      label: 'Roles',
      route: '/cms/administration/roles',
      icon: faAddressCard,
    },
    privileges: {

      type: 'link',
      label: 'Privileges',
      route: '/cms/administration/privilages',
      icon: faAddressCard,
    },
    //   publishSettings: {

    //     type: 'link',
    //     label: 'Publish Settings',
    //     route: '/cms/transcoding/all_publish_settings',
    //     icon: faAddressCard,
    // },
    catalogs: {
      type: 'link',
      label: 'Catalogs',
      route: '/cms/transcoding/catalogs',
      icon: faAddressCard,
    },

    Stats: {
      type: 'link',
      label: 'Stats',
      route: '/cms/transcoding/stats',
      icon: faAddressCard,
    },


    DRM: {
      type: 'link',
      label: 'DRM',
      icon: faFolderOpen,
      route: '/cms/drm',
    },

    reports: {
      type: 'dropdown',
      label: 'Reports',
      icon: faFolderOpen,
      children: [

        {
          type: 'link',
          label: 'Subscriptions Reports',
          icon: faFolderOpen,
          route: '/cms/report/subscription_report',
        },
        {
          type: 'link',
          label: 'User Reports',
          icon: faFolderOpen,
          route: '/cms/report/first_purchase_report',
        },
      ]
    },

    subscription: {
      type: 'link',
      label: 'Subscriptions Reports',
      icon: faFolderOpen,
      route: '/cms/report/subscription_report',
    },

  }

  content_editor: any = [
    {
      type: 'subheading',
      label: 'Features',
      children: []
    },

    {
      type: 'dropdown',
      label: 'Content Management',
      icon: faFolderOpen,
      children: [
        // route has to be changed
        {
          type: 'link',
          label: 'Catalogs',
          route: '/cms/catalogs',
          icon: faAddressCard,
        },
        {
          type: 'link',
          label: 'Containers',
          route: '/cms/media_list',
          icon: faAddressCard,
          icon1: faAddressCard,
        },
        {
          type: 'link',
          label: 'All Contents',
          route: '/cms/all-contents',
          icon: faAddressCard,
          icon1: faAddressCard,
        },
        {
          type:'link',
          label:'Bulk Upload/Update Info',
          route: '/cms/bulk_list',
          icon: faAddressCard,
        },
        
      ]
    },
  ]

  customer_support: any = [
    {
      type: 'subheading',
      label: 'Features',
      children: []
    },

    {
      type:'dropdown',
      label:'Subsription Plans',
      icon:faFolderOpen,
      children:[

            // {
            //   type: 'link',
            //   label: 'View All Plans',
            //   route: '/cms/monetization/subscription/view-all-plans',
            //   icon: faAddressCard,
            // },
            {
              type: 'link',
              label: 'End User Details',
              route: '/cms/monetization/subscription/end-user-details',
              icon: faAddressCard,
            },
            {
              type: 'link',
              label: 'Add End User',
              route: '/cms/monetization/subscription/add-end-user',
              icon: faAddressCard,
            },
            {
              type: 'link',
              label: 'Transaction Details',
              route: '/cms/monetization/subscription/transaction-details',
              icon: faAddressCard,
            },
          

        
      ]
    },


  ]


  defaultItemsForNavigation: any = [
    // {
    //   type: 'link',
    //   label: 'Dashboard',
    //   route: '/cms/dashboard',
    //   icon: icDashboard,
    //   routerLinkActiveOptions: { exact: true }

    // },
    {
      type: 'subheading',
      label: 'Features',
      children: []
    },
    // {
    //   type: 'dropdown',
    //   label: 'Administration',
    //   icon: faFolderOpen,
    //   children: []
    // },

    {
      type: 'dropdown',
      label: 'Content Management',
      icon: faFolderOpen,
      children: [
        // route has to be changed
        {
          type: 'link',
          label: 'Catalogs',
          route: '/cms/catalogs',
          icon: faAddressCard,
        },
        {
          type: 'link',
          label: 'Containers',
          route: '/cms/media_list',
          icon: faAddressCard,
          icon1: faAddressCard,
        },
        {
          type: 'link',
          label: 'All Contents',
          route: '/cms/all-contents',
          icon: faAddressCard,
          icon1: faAddressCard,
        },
        {
          type:'link',
          label:'Bulk Upload/Update Info',
          route: '/cms/bulk_list',
          icon: faAddressCard,
        },
        
      ]
    },
 
    {
      type:'dropdown',
      label:'Monetization',
      icon:faFolderOpen,
      children:[
        {
          type:'dropdown',
          label:'Content Control',
          icon:faFolderOpen,
          children:[
            // {
            //       type: 'link',
            //       label: 'Add Content Control',
            //       route: '/cms/monetization/add-new-content-control',
            //       icon: faAddressCard,
            // },
            {
              type: 'link',
              label: 'All Content Control',
              route: '/cms/monetization/all-content-control',
              icon: faAddressCard,
        }

          ]
        },
        {
          type:'dropdown',
          label:'Subsription Plans',
          icon:faFolderOpen,
          children:[

            {
              type: 'link',
              label: 'View All Plans',
              route: '/cms/monetization/subscription/view-all-plans',
              icon: faAddressCard,
            },
            {
              type: 'link',
              label: 'End User Details',
              route: '/cms/monetization/subscription/end-user-details',
              icon: faAddressCard,
            },
            {
              type: 'link',
              label: 'Add End User',
              route: '/cms/monetization/subscription/add-end-user',
              icon: faAddressCard,
            },
            {
              type: 'link',
              label: 'Transaction Details',
              route: '/cms/monetization/subscription/transaction-details',
              icon: faAddressCard,
            },
          ]

        }
      ]
    },

    {
      type:'dropdown',
      label:'Reports',
      icon:faFolderOpen,
      children:[
        {
          type: 'link',
          label: 'Subscriptions Reports',
          icon: faFolderOpen,
          route: '/cms/report/subscription_report',
        },
        {
          type: 'link',
          label: 'User Reports',
          icon: faFolderOpen,
          route: '/cms/report/first_purchase_report',
        },
      ]
    },

    {
        type:'link',
        label:'Coupons',
        icon:faFolderOpen,
        route:'/cms/coupon/coupon'
    },

    {
        type:'dropdown',
        label:'Administration',
        icon:faFolderOpen,
        children:[
          {
          type: 'dropdown',
          label: 'User Management',
          icon: faAddressCard,
          children:[
            {
              type: 'link',
              label: 'Add User',
              route: '/cms/user_managment/user_add',
              icon: faAddressCard,
            },
            {
              type: 'link',
              label: 'All Users',
              route: '/cms/user_managment/all_users_list',
              icon: faAddressCard,
            }
          ]
          },
          {

            type: 'link',
            label: 'Platform Settings',
            route: '/cms/platform_settings',
            icon: faAddressCard,
          },
          // {
          //   type: 'dropdown',
          //   label: 'Media Settings',
          //   icon: faAddressCard,
          //   children:[]
          // },

        {

          type: 'link',
          label: 'Roles',
          route: '/cms/administration/roles',
          icon: faAddressCard,
        },
        // {
        //   type: 'link',
        //   label: 'Mail Templates',
        //   route: '/cms/administration/mail_templates',
        //   icon: faAddressCard,
        // }
      ]
      },

      {
        type:'link',
        label:'Activity Tracker',
        icon:faFolderOpen,
        route:'/cms/activity_tracker'
      },

      // Transssss

      // {
      //   type: 'dropdown',
      //   label: 'Transcoding',
      //   icon: faFolderOpen,
      //   children: [
      //     // {
      //     //   type: 'link',
      //     //   label: 'Catalogs',
      //     //   route: '/cms/transcoding/catalogs',
      //     //   icon: faAddressCard,
  
      //     // },
      //     {
      //       type: 'link',
      //       label: 'Stats',
      //       route: '/cms/transcoding/stats',
      //       icon: faAddressCard,
      //     },
      //     // {
      //     //   type: 'link',
      //     //   label: 'List of Items',
      //     //   route: '/cms/transcoding/list_of_items',
      //     //   icon: faAddressCard,
      //     // },
  
      //     {
  
      //       type: 'link',
      //       label: 'Publish Settings',
      //       route: '/cms/transcoding/publish_settings',
      //       icon: faAddressCard,
      //     },
      //     {
  
      //       type: 'link',
      //       label: 'Profile Settings',
      //       route: '/cms/transcoding/transcoding_profile_settings',
      //       icon: faAddressCard,
      //     }
  
  
      //   ]
      // },
      // {
      //   type:'dropdown',
      //   label:'Vendor Management',
      //   icon:faFolderOpen,
      //   children:[]
      // },
      // {
      //   type:'dropdown',
      //   label:'Monetization',
      //   icon:faFolderOpen,
      //   children:[
      //     {
      //       type:'dropdown',
      //       label:'Content Control',
      //       icon:faFolderOpen,
      //       children:[
      //         {
      //               type: 'link',
      //               label: 'All Content Control',
      //               route: '/cms/administration/mail_templates',
      //               icon: faAddressCard,
      //         }

      //       ]
      //     },
      //   ]
      // },
      // {
      //   type:'link',
      //   label:'Coupons',
      //   icon:faFolderOpen,
      //   route:'/cms/coupon/coupon'
      // },
      // {
      //   type:'link',
      //   label:'Media Analytics',
      //   icon:faFolderOpen,
      //   route:'#'
      // },
  ]

  CMSManager =
    {
      type: 'link',
      label: 'Business Group',
      route: '/cms/business-group',
      icon: faAddressCard,
      routerLinkActiveOptions: { exact: true }

    }



  privilegesSet: any = false;

  path = location.href.split("#")[1];

  constructor(private configService: ConfigService,
    private styleService: StyleService,
    private renderer: Renderer2,
    private platform: Platform,
    @Inject(DOCUMENT) private document: Document,
    @Inject(LOCALE_ID) private localeId: string,
    private layoutService: LayoutService,
    private route: ActivatedRoute,
    private navigationObj: NavigationService,
    private navigationService: NavigationService,
    private splashScreenService: SplashScreenService,
    private userService:UsersService,
    private appConfigService: AppConfigService,
    private CookieService: CookieService,
    private businessGroupManagementService: BusinessGroupManagementService,
    private broadcastService: BroadcastService,
    private router: Router
  ) {

   
    // if(this.CookieService.get('bg_id') && this.CookieService.get('user_role') === 'cms_manager' && this.CookieService.get('bg_user_name')){
    //   // ;
    //   this.broadcastService.on(new Message('switchToPrivileges', null)).subscribe(event => this.changeRouteAndSideNav(event.payload));
    //   //console.log('switchToPrivileges called')
    // }

    // ;



    this.broadcastService.on(new Message('changeSideNavOnSwitch', null)).subscribe(event => this.changeRouteToCMSManager())
    Settings.defaultLocale = this.localeId;

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    /**
     * Customize the template to your needs with the ConfigService
     * Example:
     *  this.configService.updateConfig({
     *    sidenav: {
     *      title: 'Custom App',
     *      imageUrl: '//placehold.it/100x100',
     *      showCollapsePin: false
     *    },
     *    showConfigButton: false,
     *    footer: {
     *      visible: false
     *    }
     *  });
     */

    /**
     * Config Related Subscriptions
     * You can remove this if you don't need the functionality of being able to enable specific configs with queryParams
     * Example: example.com/?layout=apollo&style=default
     */
    this.route.queryParamMap.pipe(
      map(queryParamMap => queryParamMap.has('rtl') && coerceBooleanProperty(queryParamMap.get('rtl'))),
    ).subscribe(isRtl => {
      this.document.body.dir = isRtl ? 'rtl' : 'ltr';
      this.configService.updateConfig({
        rtl: isRtl
      });
    });

    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('layout'))
    ).subscribe(queryParamMap => this.configService.setConfig(queryParamMap.get('layout') as ConfigName));

    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('style'))
    ).subscribe(queryParamMap => this.styleService.setStyle(queryParamMap.get('style') as Style));


    this.navigationService.items = []


    this.navigationObj.items = [{
      type: 'link',
      label: 'Dashboard',
      route: '/cms/dashboard',
      icon: icDashboard,
      routerLinkActiveOptions: { exact: true }

    },
    {
      type: 'subheading',
      label: 'Features',
      children: []
    },
    {
      type: 'dropdown',
      label: 'Content Management',
      icon: faFolderOpen,
      children: [
        // route has to be changed
        {
          type: 'link',
          label: 'Catalogs',
          route: '/cms/catalogs',
          icon: faAddressCard,
        },
        // {

        //   type: 'link',
        //   label: 'All Content',
        //   route: '/cms/#',
        //   icon: faAddressCard,
        // },
        // {

        //   type: 'link',
        //   label: 'Top Tabs',
        //   route: '/cms/#',
        //   icon: faAddressCard,
        // },
        {
          type: 'link',
          label: 'Containers',
          route: '/cms/media_list',
          icon: faAddressCard,
          icon1: faAddressCard,
          // badge: {
          //   value: '16',
          //   bgClass: 'bg-cyan',
          //   textClass: 'text-cyan-contrast',
          // }
        },
        // {
        //   type: 'dropdown',
        //   label: 'EPG',
        //   icon: faAddressCard,
        //   // route has to be changed
        //   children:[
        //     {
        //       type: 'link',
        //       label: 'Linear List',
        //       route: '/cms/',

        //     },{
        //       type: 'link',
        //       label: 'Asset Info',
        //       route: '/cms/',

        //     },
        //     {
        //       type: 'link',
        //       label: 'Program Scheduler',
        //       route: '/cms/',

        //     }
        //   ]
        // },
        // {
        //   type:'link',
        //   label:'Remove items',
        //   route: '/cms/add_removable_contents',
        //   icon: faAddressCard,
        // },
        // {
        //   type:'link',
        //   label:'Manage Smart URL',
        //   route: '/cms/get_smart_url',
        //   icon: faAddressCard,
        // },
        // {
        //   type:'link',
        //   label:'Bulk Upload/Update Info',
        //   route: '/cms/bulk_list',
        //   icon: faAddressCard,
        // },

      ]
    },
      // {
      //   type:'dropdown',
      //   label:'Administration',
      //   icon:faFolderOpen,
      //   children:[
      //     {
      //     type: 'dropdown',
      //     label: 'User Management',
      //     icon: faAddressCard,
      //     children:[
      //       {
      //         type: 'link',
      //         label: 'Add User',
      //         route: '/cms/user_managment/user_add',
      //         icon: faAddressCard,
      //       },
      //       {
      //         type: 'link',
      //         label: 'All Users',
      //         route: '/cms/user_managment/all_users_list',
      //         icon: faAddressCard,
      //       }
      //     ]
      //     },
      //     // {
      //     //   type: 'dropdown',
      //     //   label: 'Media Settings',
      //     //   icon: faAddressCard,
      //     //   children:[]
      //     // },

      //   {

      //     type: 'link',
      //     label: 'Roles',
      //     route: '/cms/administration/roles',
      //     icon: faAddressCard,
      //   },
      //   // {
      //   //   type: 'link',
      //   //   label: 'Mail Templates',
      //   //   route: '/cms/administration/mail_templates',
      //   //   icon: faAddressCard,
      //   // }
      // ]
      // },
      // {
      //   type:'dropdown',
      //   label:'Vendor Management',
      //   icon:faFolderOpen,
      //   children:[]
      // },
      // {
      //   type:'dropdown',
      //   label:'Monetization',
      //   icon:faFolderOpen,
      //   children:[
      //     {
      //       type:'dropdown',
      //       label:'Content Control',
      //       icon:faFolderOpen,
      //       children:[
      //         {
      //               type: 'link',
      //               label: 'All Content Control',
      //               route: '/cms/administration/mail_templates',
      //               icon: faAddressCard,
      //         }

      //       ]
      //     },
      //   ]
      // },
      // {
      //   type:'link',
      //   label:'Coupons',
      //   icon:faFolderOpen,
      //   route:'/cms/coupon/coupon'
      // },
      // {
      //   type:'link',
      //   label:'Media Analytics',
      //   icon:faFolderOpen,
      //   route:'#'
      // },


      {
        type:'dropdown',
        label:'Reports',
        icon:faFolderOpen,
        children:[
          {
            type: 'link',
            label: 'Subscriptions Reports',
            icon: faFolderOpen,
            route: '/cms/report/subscription_report',
          },
          {
            type: 'link',
            label: 'User Reports',
            icon: faFolderOpen,
            route: '/cms/report/first_purchase_report',
          },
          {
            type: 'link',
            label: 'Transcations Reports',
            icon: faFolderOpen,
            route: '/cms/report/transaction_report',
          },
          {
            type: 'link',
            label: 'Users Report',
            icon: faFolderOpen,
            route: '/cms/report/user_report',
          },
          {
            type: 'link',
            label: 'Usage Report ',
            icon: faFolderOpen,
            route: '/cms/report/usage_report',
          },



        ]
      },




      // {
      //   type: 'dropdown',
      //   label: 'Application',
      //   icon: faFolderOpen,
      //   children: [
      //     {
      //       type: 'link',
      //       label: 'Configuration',
      //       icon: faAddressCard,
      //       route: '/cms/apps-config',
      //     }
      //   ]
      // },
      // {
      //   type: 'link',
      //   label: 'Bulk Upload/Update Info',
      //   icon: faFolderOpen,
      //   route: '',
      // }

    ];

  }

  ngAfterViewInit() {
    let ispath = this.path === '/cms/business-group'
    // ;
    if (this.CookieService.get('user_role') === 'cms_manager' && ispath) {
      this.navigationService.items = []
      this.navigationService.items.push(this.CMSManager);
      //console.log(this.CMSManager + ' this.CMSManager ngAfterViewInit')
      this.getBusinessGroup(false)


    }

  
    // //console.log('switchToPrivileges called ' + this.CookieService.get('bg_id') && this.CookieService.get('user_role') === 'cms_manager' && this.CookieService.get('bg_user_name'))
  }

  // ngAfterViewInit(){
  //   // ;
  //   let ispath =  this.path === '/cms/business-group'
  //   //console.log(ispath)
  //   if(this.CookieService.get('user_role') === 'cms_manager' && ispath){
  //     this.navigationService.items = this.CMSManager;
  //     // this.getBusinessGroup()
  //   }else if(this.CookieService.get('bg_id') && this.CookieService.get('user_role') === 'cms_manager' && this.CookieService.get('bg_user_name')){
  //     this.changeRouteAndSideNav(this.CookieService.get('userPrivilegesObj'))

  //   }
  // }

  ngOnInit() {
    // ;
    // Refresh the cms_keys cookies on every app boot so existing sessions self-heal
    // (they are otherwise only written at login).
    const cmsToken = this.CookieService.get('user_cms_token');
    if (cmsToken && cmsToken !== 'undefined') {
      this.appConfigService.loadCmsKeys(cmsToken);
    }
    this.userPrivileges = localStorage.getItem('user_privileges') !== 'undefined' ? JSON.parse(localStorage.getItem('user_privileges')) : null
    this.service_brought = this.CookieService.get('service_brought') !== 'undefined' ? this.CookieService.get('service_brought') : null
   
    this.getUserPrivileges(this.userPrivileges);
    this.navigationItems();
    if (this.CookieService.get('user_role') === 'cms_manager' && this.path !== '/cms/business-group') {
      this.getBusinessGroup(false);
    }

  }

  ngDoCheck() {
    // //console.log('ngDoCheck()')
    // //console.log('userPrivileges', this.userPrivileges)
    // //console.log(userPrivileges, userPrivileges !== this.userPrivileges)
    if (userPrivileges !== this.userPrivileges && userPrivileges !== null) {
      // //console.log(userPrivileges, userPrivileges !== this.userPrivileges)
      this.setUserPrivileges()
    }

    // && this.CookieService.get('user_role') === 'cms_manager'  && this.CookieService.get('bg_user_name') !== ''
    if (this.CookieService.get('bg_id').length !== 0) {
      this.broadcastService.on(new Message('switchToPrivileges', null)).subscribe(event => this.changeRouteAndSideNav(event.payload));
      
    }

  }

  escapeUnderscore(char: any) {
    let char1 = char.replaceAll(/_/gi, ' ')
    return char1
  }

  changeRouteAndSideNav(data) {
    // 
    // //console.log('changeRouteAndSideNav', data)
    this.navigationService.items = []
    this.getUserPrivileges(data)
    this.navigationItems();
    this.router.navigate(['/cms/catalogs']);
  }

  changeRouteToCMSManager() {
    this.navigationService.items = []
    this.navigationService.items.push(this.CMSManager);
    this.getBusinessGroup(true);
  }


  setUserPrivileges() {
    // //console.log(this.userPrivileges);
    if (this.privilegesSet === false) {
      // //console.log('setUserPrivileges', this.privilegesSet)
      this.userPrivileges = localStorage.getItem('user_privileges') !== 'undefined' ? JSON.parse(localStorage.getItem('user_privileges')) : null
      this.getUserPrivileges(this.userPrivileges);
      this.navigationItems();
      if (userPrivileges != null) {
        // ;
        this.privilegesSet = true
      }
    }
  }


  getUserPrivileges(data) {
    let values = data;
    if (values !== null) {
      this.privilegesSet = true;
      for (let i = 0; i < values.length; i++) {
        this.privilegesObj[values[i]] = true
      }
      // console.log(this.privilegesObj);

      //setting the privileges obj in cookies to make the data accessible to all other components
      this.CookieService.set('userPrivilegesObj', JSON.stringify(this.privilegesObj));
    }

  }

  // getSystemCatalogInfo(bg_id){
  //   this.userService.getSystemCatalogInfo(bg_id).subscribe((response) => {
  //     systemCatalogsInfo = response.data
  //   },(error) => {
  //     console.log(error)
  //   })
  //  }

  navigationItems() {

    if(this.CookieService.get('business_group_id')){
      //this.getSystemCatalogInfo(this.CookieService.get('business_group_id'))
    
    }
    
    this.navigationService.items = []
    if(this.privilegesObj['administration']){
      this.navigationService.items.push(...this.defaultItemsForNavigation)
    }else if(this.CookieService.get('user_role')==='content_editor'){
      this.navigationService.items.push(...this.content_editor)
    }else if(this.CookieService.get('user_role')==='customer_support'){
      this.navigationService.items.push(...this.customer_support)
    } 
  

    // if (this.privilegesObj['administration'] || this.privilegesObj['create_user'] || this.privilegesObj['platform_settings'] || this.CookieService.get('user_role') === 'admin') {
    //   this.navigationService.items.push(this.sideNavItems.administration )
    //   // this.navigationService.items.push(this.sideNavItems.configurations)
    // }


    // if (this.privilegesObj['transcode']) {
    //   this.navigationService.items.push(this.sideNavItems.transcoding)
    //   this.navigationService.items.push(this.sideNavItems.Stats)
    // }

    if(this.privilegesObj['drm']){
      this.navigationService.items.push(this.sideNavItems.DRM)
    }
    
    if (this.service_brought?.toLowerCase() === 'transcoding') {
      // if (this.privilegesObj['transcode']) {
      //   this.navigationService.items.push(this.sideNavItems.Stats)
      // }
      if (this.privilegesObj['transcode']) {
        this.navigationService.items.push(this.sideNavItems.catalogs)
      }
    } else if (this.service_brought?.toLowerCase() === 'ott') {
      this.navigationService.items.push(this.sideNavItems.content_management)
      this.navigationService.items.push(this.sideNavItems.monetization)
      this.navigationService.items.push(this.sideNavItems.reports)
    }

  



    for (let i = 0; i < this.navigationService.items.length; i++) {


      let length = this.navigationService.items.length;
      //content management - catalog, containers

      if (this.navigationService.items[i].label === 'Administration' && this.navigationService.items[i]['children'].length === 0) {
        if (this.privilegesObj['user_management'] || this.privilegesObj['create_user']) {
          this.navigationService.items[i]['children'].push(this.sideNavItems.user_management);
        }

        if (this.privilegesObj['create_user']) {
          this.sideNavItems.user_management.children.push(this.sideNavItems.add_user)
        }

        if (this.privilegesObj['platform_settings']) {
          this.navigationService.items[i]['children'].push(this.sideNavItems['platformSettings'])
        }

        if (this.CookieService.get('user_role') === 'admin' || this.CookieService.get('user_role') === 'cms_manager') {
          this.navigationService.items[i]['children'].push(this.sideNavItems.roles)
          this.navigationService.items[i]['children'].push(this.sideNavItems.privileges)
        }

      }


    }

   
  }

  getBusinessGroup(bgSideNav) {

    this.businessGroupManagementService.BusinessgroupTable('', '', '').subscribe((response) => {
      if (response.data) {
        let path = location.href.split("#")[0] != "/" ? location.href.split("#")[0] : null;

        const navigation = {
          type: 'dropdown',
          label: 'Switch to',
          icon: faFolderOpen,
          children: []
        }


        if (this.path === '/cms/business-group' || bgSideNav) {
          response.data.forEach((ele) => {
            if (ele.admin_base_url) {
              const children = {
                type: 'link',
                label: this.escapeUnderscore(ele.groupname),
                routeToUrl: ele.bg_id,
                // route: ele.admin_base_url,
                icon: faAddressCard,
              }

              navigation.children.push(children)
            }

          })
          this.navigationService.items = [];
          this.navigationService.items.push(this.CMSManager);
          this.navigationService.items.push(navigation)
        }

        //console.log(this.CMSManager)

        this.broadcastService.dispatch(new Message('switchToData', response.data))

      }
    }, (error) => {

    })
  }
}


